/** Kart ödemesi (3D) sırasında sepet/adres — başarısız ödeme sonrası tekrar dene.
 * sessionStorage bazı 3D yönlendirmelerinde kaybolabiliyor; localStorage yedek.
 */
const KEY = 'pendingCheckout';

function _parse(raw) {
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    if (data?.savedAt && Date.now() - data.savedAt > 24 * 60 * 60 * 1000) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function savePendingCheckout(data) {
  const payload = JSON.stringify({
    ...data,
    savedAt: Date.now(),
  });
  try {
    sessionStorage.setItem(KEY, payload);
  } catch (e) {
    console.warn('pendingCheckout session save failed', e);
  }
  try {
    localStorage.setItem(KEY, payload);
  } catch (e) {
    console.warn('pendingCheckout local save failed', e);
  }
}

export function readPendingCheckout() {
  try {
    const fromSession = _parse(sessionStorage.getItem(KEY));
    if (fromSession?.items?.length) return fromSession;
  } catch {
    /* ignore */
  }
  try {
    const fromLocal = _parse(localStorage.getItem(KEY));
    if (fromLocal) {
      // session'a geri yaz (aynı oturumda hızlı okuma)
      try {
        sessionStorage.setItem(KEY, JSON.stringify(fromLocal));
      } catch {
        /* ignore */
      }
      return fromLocal;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function clearPendingCheckout() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
